import Layout from '@/layout';
var merchantRouter = {
  path: '/hospital',
  component: Layout,
  redirect: '/hospital',
  name: 'Hospital',
  meta: {
    title: '医院管理',
    icon: 'school'
  },
  children: [{
    path: 'list',
    name: 'HospitalList',
    component: function component() {
      return import('@/views/hospital/list');
    },
    meta: {
      title: '医院列表',
      icon: ''
    }
  }, {
    path: 'docter',
    name: 'DocterList',
    component: function component() {
      return import('@/views/hospital/docter/index.vue');
    },
    meta: {
      title: '医生管理',
      icon: ''
    }
  }, {
    path: 'department',
    name: 'DepartmentList',
    component: function component() {
      return import('@/views/hospital/department/index.vue');
    },
    meta: {
      title: '科室管理',
      icon: ''
    },
    children: []
  }, {
    path: 'department/doctor',
    name: 'DepartmentDoctorView',
    component: function component() {
      return import('@/views/hospital/department/doctor.vue');
    },
    meta: {
      title: '查看科室医生',
      icon: ''
    }
  }]
};
export default merchantRouter;